import { useEffect, useState } from 'react';
import { getPendingBalanceSummary } from '../services';
import { IPendingBalanceSummaryItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function usePendingBalanceSummary(options?: {
	team?: string;
	enabled?: boolean;
}): HookState<IPendingBalanceSummaryItem[]> {
	const [state, setState] = useState<HookState<IPendingBalanceSummaryItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const team = options?.team;
	const enabled = options?.enabled ?? true;

	useEffect(() => {
		if (!enabled) return;

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getPendingBalanceSummary({ team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [team, enabled]);

	return state;
}
